<div class="p-d-flex p-jc-center p-mt-4 p-mb-4" *ngIf="loading === true">
    <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
</div>
